import React from 'react'
import Header from './header'
import TaxSaving from './taxSavings'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTaxSavingRecord, getSavingTypes, getTaxSavingReport } from '../../../actions/employeeActions'
import _ from 'lodash';
import { getFormattedTiming, frequencyItem, formatAmount, isEmpty2 } from '../../../common/utils';
import TaxSavingReport from './taxSavingReport'

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            taxSavingId: '',
            employeeId: '',
            empName: '',
            rowBackgroundColor: '',
            selectedFormat: 'Format1',
            financialYear: new Date().getFullYear() - 1
        }
        this.handleEmployeeChange = this.handleEmployeeChange.bind(this);
        this.handleFinancialYearChange = this.handleFinancialYearChange.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
    }

    componentDidMount() {
        this.props.getSavingTypes()
        this.fetchData(this.props.userId, this.state.financialYear);
    }

    getTaxSavingReport = (userId, financialYear) => {
        userId = userId != '' ? document.getElementById('inputUserId').value : this.props.dashboardData.employeeId;
        financialYear = financialYear != '' ? document.getElementById('inputFinancialYear').value : new Date().getFullYear();
        this.props.getTaxSavingReport({ employeeId: userId, financialYear: financialYear })
    }

    selectTaxSavingRowData = (taxsavingId, name) => {
        this.setState({
            taxSavingId: taxsavingId,
            empName: name,
            rowBackgroundColor: "#ffefbb"
        })
    }

    getTaxSavingRecords(taxSavingRecords) {
        const parentRecords = _.orderBy(_.filter(taxSavingRecords, (item) => { return item.TaxSavingRecordId === item.SetId }), 
        ['FullName', 'TaxCategoryCode', 'TaxSavingTypeName', 'SavingDate'], ['asc','asc','asc', 'desc']);
        _.map(parentRecords, (item) => {
            item['Amount'] = 0;
            const lineItems = _.filter(taxSavingRecords, (obj) => { return obj.SetId === item.TaxSavingRecordId && obj.TaxSavingRecordId !== item.TaxSavingRecordId });
            const savingDate = _.minBy(lineItems, 'SavingDate');
            item['RecurringFrequencyName'] = frequencyItem(item.RecurringFrequency);
            item['Amount'] = formatAmount(_.sumBy(lineItems, 'Amount'), false, false, true);
            item['ItemCount'] = _.filter(lineItems, (item) => { return item.ReceiptSubmitted }).length + ' / ' + lineItems.length;
            item['SavingDate'] = getFormattedTiming(savingDate ? savingDate.SavingDate : new Date(), 'DD-MMM-YYYY');
            item['TaxSavingLineItems'] = lineItems;
        })

        return parentRecords;
    }

    handleFormatChange = (event) => {
        this.setState({ selectedFormat: event.target.value })
        this.fetchData(this.state.employeeId, this.state.financialYear, event.target.value);
    }

    onRefresh(employeeId, financialYear, selectedFormat) {
        this.fetchData(employeeId, financialYear, selectedFormat);
    }

    handleEmployeeChange(selectedOption) {
        if (selectedOption) {
            this.setState({ employeeId: selectedOption.Value });
        } else {
            this.setState({ employeeId: null });
        }
        this.fetchData(selectedOption.Value, this.state.financialYear, this.state.selectedFormat);
    }

    fetchData(employeeId, financialYear, selectedFormat) {
        employeeId = isEmpty2(employeeId) ? this.props.dashboardData.employeeId : employeeId;
        if (selectedFormat === 'Format2') {
            this.props.getTaxSavingReport({ employeeId: employeeId, financialYear: financialYear });
        } else {
            this.props.getTaxSavingRecord({ employeeId: employeeId, financialYear: financialYear });
        }
    }

    handleFinancialYearChange(selectedOption) {
        if (selectedOption) {
            this.setState({ financialYear: selectedOption.value });
        } else {
            this.setState({ financialYear: new Date().getFullYear() - 1 });
        }
        this.fetchData(this.state.employeeId, selectedOption.value, this.state.selectedFormat);
    }

    render() {
        const employeeData = this.props.employeeData;
        if (employeeData && employeeData.taxSavingRecords.isLoading) return <></>;
        if (this.props.dashboardData && this.props.dashboardData.isLoading) return <></>;
        const taxSavingRecords = this.getTaxSavingRecords(this.props.taxSavings);
        let editTaxSavingReceipt = [];
        const taxSavingRecordId = this.state.taxSavingId;

        if (taxSavingRecordId && taxSavingRecordId !== '') {
            editTaxSavingReceipt = _.filter(taxSavingRecords, { TaxSavingRecordId: taxSavingRecordId });
        }
        const employeeId = isEmpty2(this.state.employeeId) ? this.props.dashboardData.employeeId : this.state.employeeId;
        const isAdmin = (this.props.dashboardData.userRole === 'Admin' || this.props.userId.toUpperCase() === 'ADBDC254-D284-438C-B7F0-D31F3184C984' || this.props.userId.toUpperCase() === 'C5D9E4DC-2E7F-4F60-9546-BC34E6806BE6');

        return (
            <>
                <main id="content" className="app__content">
                    <Header userId={this.props.userId} employeeId={employeeId} empName={this.state.empName} financialYear={this.state.financialYear} editTaxSavingReceipt={editTaxSavingReceipt}
                        employeeData={this.props.employeeData} dashboardData={this.props.dashboardData}
                        getTaxSavingReport={this.getTaxSavingReport}
                        taxSavingId={taxSavingRecordId}
                        rowBackgroundColor={this.state.rowBackgroundColor} selectedFormat={this.state.selectedFormat} handleFormatChange={this.handleFormatChange}
                        handleEmployeeChange={this.handleEmployeeChange} handleFinancialYearChange={this.handleFinancialYearChange}
                        onRefresh={this.onRefresh} isAdmin={isAdmin}
                        taxSavingRecords={taxSavingRecords}
                    />
                    {
                        this.state.selectedFormat === 'Format1' && employeeData ?
                            <TaxSaving isAdmin={isAdmin} taxSavingRecords={taxSavingRecords} employeeData={this.props.employeeData} dashboardData={this.props.dashboardData} selectTaxSavingRowData={this.selectTaxSavingRowData} taxSavingRecordId={taxSavingRecordId} employeeId={this.state.employeeId} rowBackgroundColor={this.state.rowBackgroundColor} /> :
                            <TaxSavingReport employeeData={this.props.employeeData} selectedFormat={this.state.selectedFormat} />
                    }
                </main>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        taxSavings: state.employeeData.taxSavingRecords.taxSavings
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getTaxSavingRecord, getSavingTypes, getTaxSavingReport }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(Index)
